export enum TierEnum {
  Tier1 = 'Tier1',
  Tier2 = 'Tier2',
  Tier3 = 'Tier3',
}

export enum TierExpressionEnum {
  CompulsoryExcess = 'CompulsoryExcess',
}

export enum TierFeatureType {
  Checkbox = 'Checkbox',
  Expression = 'Expression',
  Text = 'Text',
}
